'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _NitroTextArea = require('./NitroTextArea');

var _NitroTextArea2 = _interopRequireDefault(_NitroTextArea);

var _styles = require('./styles');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroTextField = function (_Component) {
  _inherits(NitroTextField, _Component);

  function NitroTextField(props) {
    _classCallCheck(this, NitroTextField);

    var _this = _possibleConstructorReturn(this, (NitroTextField.__proto__ || Object.getPrototypeOf(NitroTextField)).call(this, props));

    _this.handleInputBlur = function (event) {
      _this.setState({ isFocused: false });

      if (typeof _this.props.onBlur === 'function') {
        _this.props.onBlur(event);
      }
    };

    _this.handleInputChange = function (event) {
      if (!_this.props.hasOwnProperty('value')) {
        _this.setState({ hasValue: (0, _helpers.hasValue)(_this.input.value) });
      }

      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(event, _this.input.value);
      }
    };

    _this.handleInputFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }
      _this.setState({ isFocused: true });

      if (typeof _this.props.onFocus === 'function') {
        _this.props.onFocus(event);
      }
    };

    _this.handleHeightChange = function (event, height) {
      var newHeight = height + (_this.props.floatingLabelText ? 48 : 24);

      _this.setState({
        fieldHeight: newHeight + 'px'
      });
    };

    var defaultValue = props.defaultValue,
        floatingLabelText = props.floatingLabelText,
        hintText = props.hintText,
        id = props.id,
        name = props.name,
        showWarnings = props.showWarnings,
        value = props.value;


    _this.state = {
      isFocused: false,
      fieldHeight: null,
      errorText: props.errorText,
      hasValue: (0, _helpers.hasValue)(value) || (0, _helpers.hasValue)(defaultValue)
    };

    if (showWarnings) {
      console.warn(name || hintText || floatingLabelText || id, 'Nitro: We don\'t have enough information\n        to build a robust unique id for the TextField component. Please provide an id or a name.');
    }

    var randomNumber = (0, _helpers.getRandomNumber)();
    var uniqueId = [name, hintText, floatingLabelText, randomNumber].filter(function (a) {
      return a;
    }).join('-');
    _this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    return _this;
  }

  _createClass(NitroTextField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.errorText !== this.props.errorText) {
        this.setState({
          errorText: nextProps.errorText
        });
      }

      if (typeof nextProps.value !== 'undefined') {
        this.setState({
          hasValue: (0, _helpers.hasValue)(nextProps.value)
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState) || !(0, _shallowequal2.default)(this.context, nextContext);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.getInputNode() ? this.input.value : undefined;
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.props.multiLine ? this.input.getInputNode() : this.input;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.getInputNode().blur();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.getInputNode().focus();
    }
  }, {
    key: 'select',
    value: function select() {
      this.getInputNode().select();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoCapitalize = _props.autoCapitalize,
          autoComplete = _props.autoComplete,
          autoCorrect = _props.autoCorrect,
          backgroundColor = _props.backgroundColor,
          bold = _props.bold,
          className = _props.className,
          disabled = _props.disabled,
          errorStyle = _props.errorStyle,
          floatingLabelFixed = _props.floatingLabelFixed,
          floatingLabelText = _props.floatingLabelText,
          fontSize = _props.fontSize,
          fullWidth = _props.fullWidth,
          hintColor = _props.hintColor,
          hintStyle = _props.hintStyle,
          hintText = _props.hintText,
          id = _props.id,
          lineHeight = _props.lineHeight,
          multiLine = _props.multiLine,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          spellCheck = _props.spellCheck,
          style = _props.style,
          textareaStyle = _props.textareaStyle,
          type = _props.type,
          underlineShow = _props.underlineShow,
          underlineStyle = _props.underlineStyle,
          variant = _props.variant,
          width = _props.width,
          otherProps = _objectWithoutProperties(_props, ['autoCapitalize', 'autoComplete', 'autoCorrect', 'backgroundColor', 'bold', 'className', 'disabled', 'errorStyle', 'floatingLabelFixed', 'floatingLabelText', 'fontSize', 'fullWidth', 'hintColor', 'hintStyle', 'hintText', 'id', 'lineHeight', 'multiLine', 'rows', 'rowsMax', 'spellCheck', 'style', 'textareaStyle', 'type', 'underlineShow', 'underlineStyle', 'variant', 'width']);

      var inputId = id || this.uniqueId;

      var inputProps = {
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        autoCorrect: autoCorrect,
        bold: bold,
        disabled: this.props.disabled,
        floatingLabelText: floatingLabelText,
        id: inputId,
        lineHeight: lineHeight,
        multiLine: multiLine,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        spellCheck: spellCheck
      };

      var inputElement = multiLine ? _react2.default.createElement(_NitroTextArea2.default, _extends({
        hintText: hintText,
        onHeightChange: this.handleHeightChange,
        rows: rows,
        rowsMax: rowsMax,
        textareaStyle: textareaStyle,
        ref: function ref(elem) {
          _this2.input = elem;
        }
      }, otherProps, inputProps)) : _react2.default.createElement(_styles.StyledInput, _extends({
        innerRef: function innerRef(elem) {
          _this2.input = elem;
        },
        type: type
      }, otherProps, inputProps));

      return _react2.default.createElement(
        _styles.StyledTextField,
        {
          backgroundColor: backgroundColor,
          className: className,
          disabled: disabled,
          floatingLabelText: floatingLabelText,
          fontSize: fontSize,
          fullWidth: fullWidth,
          height: this.state.fieldHeight,
          id: id + '-field',
          innerRef: function innerRef(elem) {
            _this2.field = elem;
          },
          lineHeight: lineHeight,
          rows: rows,
          style: style,
          width: width
        },
        floatingLabelText && _react2.default.createElement(
          _styles.StyledLabel,
          {
            variant: variant,
            disabled: disabled,
            error: !!this.state.errorText,
            focus: this.state.isFocused,
            htmlFor: inputId,
            shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed
          },
          floatingLabelText
        ),
        hintText && _react2.default.createElement(
          _styles.StyledPlaceholder,
          {
            hintColor: hintColor,
            hintStyle: hintStyle,
            show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused
          },
          hintText
        ),
        inputElement,
        underlineShow && _react2.default.createElement(_styles.StyledUnderline, {
          variant: variant,
          disabled: disabled,
          error: !!this.state.errorText,
          focus: this.state.isFocused
        }),
        this.state.errorText && _react2.default.createElement(
          _styles.StyledError,
          {
            errorStyle: errorStyle,
            floatingLabelText: floatingLabelText,
            multiLine: multiLine
          },
          this.state.errorText
        )
      );
    }
  }]);

  return NitroTextField;
}(_react.Component);

NitroTextField.propTypes = {
  autoCapitalize: _propTypes2.default.oneOf(['on', 'off']),
  autoComplete: _propTypes2.default.oneOf(['on', 'off', 'new-password']),
  autoCorrect: _propTypes2.default.oneOf(['on', 'off']),
  bold: _propTypes2.default.bool,
  borderColor: _propTypes2.default.string,
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  disabledColor: _propTypes2.default.string,
  errorStyle: _propTypes2.default.object,
  errorText: _propTypes2.default.node,
  floatingLabelFixed: _propTypes2.default.bool,
  floatingLabelText: _propTypes2.default.node,
  fontSize: _propTypes2.default.string,
  fullWidth: _propTypes2.default.bool,
  height: _propTypes2.default.string,
  hintColor: _propTypes2.default.string,
  hintStyle: _propTypes2.default.object,
  hintText: _propTypes2.default.node,
  id: _propTypes2.default.string,
  inputStyle: _propTypes2.default.object,
  lineHeight: _propTypes2.default.number,
  multiLine: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  rows: _propTypes2.default.number,
  rowsMax: _propTypes2.default.number,
  showWarnings: _propTypes2.default.bool,
  spellCheck: _propTypes2.default.oneOf(['true', 'false']),
  style: _propTypes2.default.object,
  textareaStyle: _propTypes2.default.object,
  textColor: _propTypes2.default.string,
  type: _propTypes2.default.string,
  underlineShow: _propTypes2.default.bool,
  underlineStyle: _propTypes2.default.object,
  value: _propTypes2.default.any,
  variant: _propTypes2.default.string,
  width: _propTypes2.default.string
};

NitroTextField.defaultProps = {
  autoCapitalize: 'off',
  autoComplete: 'off',
  autoCorrect: 'off',
  disabled: false,
  floatingLabelFixed: false,
  fontSize: '16px',
  fullWidth: false,
  lineHeight: 24,
  multiLine: false,
  rows: 1,
  spellCheck: 'false',
  type: 'text',
  underlineShow: true,
  variant: 'secondary',
  width: '256px'
};

exports.default = NitroTextField;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-text-field/NitroTextField.js
// module id = 3043
// module chunks = 4